import {Box, Paper, Typography, useMediaQuery} from "@mui/material";
import React, {useMemo} from "react";
import {formatMoney} from "../../../../../../../core/services/utils/utils";
import Grid2 from "@mui/material/Unstable_Grid2";
import SummaryInfoCard from "../../../../../../components/app-specific/summary-cards/summary-info-card";
import classnames from "classnames";

const CustomerAccountSummary = ({accountSummary, loadingAccountSummary, formData}) => {
    const shouldSplitInTwo = useMediaQuery((theme) => theme.breakpoints.up('xl'));

    const accountSummaryData = useMemo(() => ({
        body1: [
            {
                id: 'priceLevel',
                title: 'Price level',
                value: formData?.priceLevels?.find(p => p.id === accountSummary?.priceLevel?.id)?.title,
            },
            {
                id: 'paymentTerms',
                title: 'Payment terms',
                value: accountSummary?.paymentTermsCode,
            },
            {
                id: 'accountReceivable',
                title: 'Account receivable',
                value: accountSummary?.accountReceivable,
                format: formatMoney,
            },
            {
                id: 'limitedCredit',
                title: 'Credit limit',
                value: accountSummary?.creditLimit,
                format: formatMoney,
            },
            {
                id: 'otherOrders',
                title: 'Other orders',
                value: accountSummary?.otherOrders,
                format: formatMoney,
            },
            {
                id: 'availableCredit',
                title: 'Available credit',
                value: accountSummary?.availableCredit,
                format: formatMoney,
            },
        ],
        body2: (accountSummary?.periodList?.reduce((acc, period) => {
            acc.push({
                id: `period-${period.name}`,
                title: `${period.name}`,
                value: period.value,
                format: formatMoney,
            });
            return acc;
        }, []) ?? []),
    }), [accountSummary, formData?.priceLevels]);

    const [body1Info, body2Info] = useMemo(() => {
        let body1Info = accountSummaryData.body1;
        let body2Info = accountSummaryData.body2;
        if (!shouldSplitInTwo || !body2Info.length) {
            body1Info = [...body1Info, ...body2Info];
            body2Info = null;
        }
        return [body1Info, body2Info];
    }, [accountSummaryData.body1, accountSummaryData.body2, shouldSplitInTwo])

    return (
        <>
            <Paper sx={{padding: 2, display: 'flex', flexDirection: 'column', position: 'relative', height: '100%'}}>
                <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2}}>
                    <Typography variant={'subtitle1'} fontWeight={600}>
                        Account Summary
                    </Typography>
                </Box>
                <Grid2 container spacing={2}>
                    <Grid2 xs={12} xl={!body2Info ? 12 : 6}>
                        <SummaryInfoCard
                            className={classnames({'pb-0': !!body2Info})}
                            body={body1Info}
                            loading={loadingAccountSummary}
                            loadingCount={body1Info.length}
                        />
                    </Grid2>
                    {
                        !!body2Info &&
                        <Grid2 xs={12} xl={6}>
                            <SummaryInfoCard
                                className={'pt-0'}
                                body={body2Info}
                                loading={loadingAccountSummary}
                                loadingCount={body2Info?.length}
                            />
                        </Grid2>
                    }
                </Grid2>
            </Paper>
        </>
    );
}

export default CustomerAccountSummary;